import {
	createValidator,
	required,
	requiredInteger,
	requiredTrueBoolean,
	email,
	minLength,
	maxLength,
} from '@sparefoot/react-core/utils/validation';

export default createValidator({
	rating: [required],
	rating_price: [requiredInteger],
	rating_paperwork: [requiredInteger],
	rating_service: [requiredInteger],
	rating_cleanliness: [requiredInteger],
	rating_recommended: [required],
	title: [required, minLength(5), maxLength(75)],
	message: [required, minLength(30), maxLength(2000)],
	nickname: [required],
	email: [required, email],
	review_tos: [requiredTrueBoolean],
});
